import FormFieldOptionInterface from '@vertical-plus/vue-js-components/lib/model/vos/form/form-field-option-interface';
import MicroServiceTagService from '@vertical-plus/vue-js-micro-service-components/lib/model/service/taxonomy/tag-service';

export default class TagService extends MicroServiceTagService
{
    public async tagFormOptionsCallback(search: string): Promise<FormFieldOptionInterface[]>
    {
        const results = await this.findTags({
            searchTerm: search,
            order: [
                {
                    key: 'title',
                    descending: false,
                },
            ],
        });

        const options: FormFieldOptionInterface[] = [];

        for (const result of results.results)
        {
            options.push({
                value: result.title,
                title: result.title,
            });
        }

        return options;
    }

    public async tagFormTitlesCallback(values: string[]): Promise<Record<string, string>>
    {
        const titles: Record<string, string> = {};

        for (const value of values)
        {
            titles[value] = value;
        }

        return titles;
    }
}